import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import it from "./locales/it.json";
import fr from "./locales/fr.json";
import zh from "./locales/zh.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import hi from "./locales/hi.json";
import ar from "./locales/ar.json";
import he from "./locales/he.json";
import ru from "./locales/ru.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            it: { translation: it },
            fr: { translation: fr },
            zh: { translation: zh },
            es: { translation: es },
            de: { translation: de },
            hi: { translation: hi },
            ar: { translation: ar },
            he: { translation: he },
            ru: { translation: ru },
        },
        fallbackLng: "en",
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18n-language",
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
